// AUTO-ESTRATTO da Bilancio.jsx (refactor strutturale Fase 10.03) — nessun cambio di logica/UI/testid.
import { formatMln, formatMlnTight, PRIZE_LABELS_IT } from "./helpers";

export function StipendiVsPremiPanel({ comparison, actualPrizes = {} }) {
    const { income_wages: iw, outflow_prizes: op, gap } = comparison;
    const gapPositive = gap >= 0;
    const prizeKeys = Object.keys(op).filter((k) => k !== "total");
    const realTotal = prizeKeys.reduce((s, k) => s + (actualPrizes?.[k] || 0), 0);
    return (
        <div className="op-card p-5 mb-6 border-l-2" style={{ borderLeftColor: gapPositive ? "rgb(var(--tc-2bb6ff))" : "rgb(var(--tc-ff3b30))" }} data-testid="stipendi-vs-premi">
            <div className="flex items-end justify-between flex-wrap gap-3 mb-4">
                <div>
                    <div className="op-label text-tffffff">// STIPENDI vs PREMI</div>
                    <p className="op-mono text-[11px] text-t8f95a3 mt-1">
                        Confronto tra ciò che incassi dalle squadre (stipendi + VG11) e i premi che ridistribuisci (escluso il TV BASE 100mln). I premi mostrano il <span className="text-tffffff">REALE</span> già distribuito e il <span className="text-t8f95a3">previsto</span> da regolamento.
                    </p>
                </div>
                <div className="text-right">
                    <div className="op-mono text-[10px] text-t8f95a3">DIFFERENZA PREVISTA</div>
                    <div className="op-heading text-3xl" style={{ color: gapPositive ? "rgb(var(--tc-2bb6ff))" : "rgb(var(--tc-ff3b30))" }} data-testid="comparison-gap">
                        {gapPositive ? "+" : "−"}{formatMln(Math.abs(gap))}
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* ENTRATE — stipendi */}
                <div className="border border-t2bb6ff/40 p-4" data-testid="comparison-income">
                    <div className="flex items-end justify-between border-b border-t22252a pb-2 mb-3">
                        <div className="op-label text-t2bb6ff">ENTRATE STIPENDI <span className="text-[9px] text-t8f95a3">(previsto)</span></div>
                        <div className="op-mono text-2xl text-t2bb6ff font-bold">{formatMln(iw.total)}</div>
                    </div>
                    <div className="space-y-1.5 op-mono text-[12px]">
                        <div className="flex justify-between"><span className="text-tc9ccd3">Prelievo stipendi (base)</span><span className="text-tffffff">{formatMln(iw.stipend_collection)}</span></div>
                        <div className="flex justify-between"><span className="text-tc9ccd3">Contributo VG11</span><span className="text-tffffff">{formatMln(iw.vg11_collection)}</span></div>
                    </div>
                </div>

                {/* USCITE — premi: REALE distribuito + previsto */}
                <div className="border border-tff3b30/40 p-4" data-testid="comparison-outflow">
                    <div className="flex items-end justify-between border-b border-t22252a pb-2 mb-3">
                        <div className="op-label text-tff3b30">USCITE PREMI <span className="text-[9px] text-t8f95a3">(reale)</span></div>
                        <div className="text-right">
                            <div className="op-mono text-2xl text-tff3b30 font-bold" data-testid="comparison-outflow-real-total">{formatMln(realTotal)}</div>
                            <div className="op-mono text-[10px] text-t8f95a3">previsto {formatMln(op.total)}</div>
                        </div>
                    </div>
                    <div className="space-y-1.5 op-mono text-[12px]">
                        {prizeKeys.map((k) => {
                            const real = actualPrizes?.[k] || 0;
                            const exp = op[k];
                            return (
                                <div key={k} className="flex justify-between">
                                    <span className="text-tc9ccd3">{PRIZE_LABELS_IT[k] || k}</span>
                                    <span className={real > 0 ? "text-tffffff" : "text-t5c6370"}>
                                        {formatMln(real)}
                                        {exp > 0 && (
                                            <span className="text-t8f95a3 ml-2 text-[11px]">(prev. {formatMlnTight(exp)})</span>
                                        )}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="mt-3 op-mono text-[11px] text-t8f95a3">
                {gapPositive
                    ? `✓ A regime, gli stipendi (con VG11) coprono i premi previsti e avanzano ${formatMln(Math.abs(gap))}. Il deficit OP totale dipende dal TV BASE (100mln × 56 = 5.6mld), non dal sistema stipendi-premi.`
                    : `⚠ A regime gli stipendi non coprono i premi previsti di ${formatMln(Math.abs(gap))}. Serve rivedere ingaggi o tabelle premi.`
                }
            </div>
        </div>
    );
}


export function RulesPanel({ divDiscounts }) {
    return (
        <div className="op-card p-5 mb-6 border-l-2 border-l-te8ff00" data-testid="rules-panel">
            <div className="op-label text-te8ff00 mb-3">// REGOLE DEL BILANCIO (Art. 7 & 9)</div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 text-[13px] text-tc9ccd3">
                <div>
                    <div className="op-heading text-base mb-2">VG11 — Impatto sul monte stipendi</div>
                    <p className="text-[12px] text-t8f95a3 mb-2">
                        Media dei VG degli 11 giocatori più forti (arrotondata <strong>per eccesso</strong>).
                        Per ogni punto sopra o sotto 80:
                    </p>
                    <table className="w-full text-[12px] op-mono">
                        <thead className="text-t8f95a3">
                            <tr><th className="text-left py-1">Divisione</th><th className="text-right py-1">% per punto</th></tr>
                        </thead>
                        <tbody>
                            <tr className="border-t border-t22252a"><td>TOP</td><td className="text-right text-tff3b30">±10%</td></tr>
                            <tr className="border-t border-t22252a"><td>DOP</td><td className="text-right">±7%</td></tr>
                            <tr className="border-t border-t22252a"><td>OPS</td><td className="text-right">±3%</td></tr>
                            <tr className="border-t border-t22252a"><td>HOPE</td><td className="text-right">±1.5%</td></tr>
                        </tbody>
                    </table>
                </div>

                <div>
                    <div className="op-heading text-base mb-2">Agevolazioni fiscali per divisione</div>
                    <p className="text-[12px] text-t8f95a3 mb-2">Sgravio applicato sul monte stipendi dopo VG11.</p>
                    <table className="w-full text-[12px] op-mono">
                        <thead className="text-t8f95a3">
                            <tr><th className="text-left py-1">Divisione</th><th className="text-right py-1">Sgravio</th></tr>
                        </thead>
                        <tbody>
                            <tr className="border-t border-t22252a"><td>TOP / DOP</td><td className="text-right">—</td></tr>
                            <tr className="border-t border-t22252a"><td>OPS</td><td className="text-right text-t2bb6ff">−{Math.round(((divDiscounts?.OPS) ?? 0.20) * 100)}%</td></tr>
                            <tr className="border-t border-t22252a"><td>HOPE</td><td className="text-right text-t2bb6ff">−{Math.round(((divDiscounts?.HOPE) ?? 0.40) * 100)}%</td></tr>
                        </tbody>
                    </table>
                </div>

                <div>
                    <div className="op-heading text-base mb-2">Tasse annuali</div>
                    <p className="text-[12px] text-t8f95a3">
                        Ogni squadra paga il <strong className="text-tffffff">10%</strong> sul proprio bilancio a fine stagione. Importo accreditato direttamente alla Cassa OP.
                    </p>
                </div>

                <div>
                    <div className="op-heading text-base mb-2">Stadio (Art. 9)</div>
                    <table className="w-full text-[11px] op-mono">
                        <thead className="text-t8f95a3">
                            <tr><th className="text-left py-1">Upgrade</th><th className="text-right py-1">Costruzione</th><th className="text-right py-1">Annuale</th></tr>
                        </thead>
                        <tbody>
                            <tr className="border-t border-t22252a"><td>Lv.1 Fondazione</td><td className="text-right">100 mln</td><td className="text-right">—</td></tr>
                            <tr className="border-t border-t22252a"><td>Lv.2a Ampliamento (+5k)</td><td className="text-right">25 mln</td><td className="text-right">5 mln</td></tr>
                            <tr className="border-t border-t22252a"><td>Lv.2b Estensione (+5 Ugly)</td><td className="text-right">50 mln</td><td className="text-right">5 mln</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="lg:col-span-2 pt-2 border-t border-t22252a">
                    <div className="op-mono text-[11px] text-t8f95a3">
                        <strong className="text-tffffff">Flusso rata stipendi:</strong>
                        <span className="text-t2bb6ff"> stipendi applicati</span>
                        <span> × </span>
                        <span className="text-te8ff00">VG11</span>
                        <span> × </span>
                        <span className="text-t2bb6ff">(1 − sgravio divisione)</span>
                        <span> ÷ 2 (mezza stagione)</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function CategoryPanel({ title, accent, total, items, labels, forecast, forecastTotal, forecastLabels, hideKeys = [], hideHint = "" }) {
    const hideSet = new Set(hideKeys);
    // Merge actual + forecast keys for ordering
    const allKeys = new Set(items.map(([k]) => k));
    if (forecast) Object.keys(forecast).forEach((k) => allKeys.add(k));
    const itemsMap = Object.fromEntries(items);

    // Hide keys with both actual=0 AND forecast=0 (no signal to show), and explicit hidden keys
    const visibleKeys = Array.from(allKeys).filter((k) => {
        if (hideSet.has(k)) return false;
        const actual = itemsMap[k] ?? 0;
        const expected = forecast?.[k] ?? 0;
        return actual !== 0 || expected !== 0;
    });

    // Recompute totals: subtract hidden items so the panel header total reflects only visible rows
    let visibleActualTotal = 0;
    let visibleForecastTotal = 0;
    visibleKeys.forEach((k) => {
        visibleActualTotal += itemsMap[k] ?? 0;
        visibleForecastTotal += forecast?.[k] ?? 0;
    });
    const finalActual = hideSet.size > 0 ? visibleActualTotal : total;
    const finalForecast = hideSet.size > 0 ? visibleForecastTotal : forecastTotal;

    return (
        <div className="op-card p-5" data-testid={`cat-${title.toLowerCase()}`}>
            <div className="flex items-end justify-between border-b border-t22252a pb-3 mb-3">
                <div className="op-label" style={{ color: accent }}>{title}</div>
                <div className="text-right">
                    <div className="op-mono text-lg" style={{ color: accent }}>{formatMln(finalActual)}</div>
                    {finalForecast != null && (
                        <div className="op-mono text-[10px] text-t8f95a3" data-testid={`${title.toLowerCase()}-forecast-total`}>
                            previsto +{formatMln(finalForecast)}
                        </div>
                    )}
                </div>
            </div>
            <div className="space-y-1.5">
                {visibleKeys.map((key) => {
                    const actual = itemsMap[key] ?? 0;
                    const expected = forecast?.[key];
                    const label = labels[key] || forecastLabels?.[key] || key;
                    return (
                        <div key={key} className="flex justify-between op-mono text-[12px]">
                            <span className="text-tc9ccd3">{label}</span>
                            <span className="text-tffffff">
                                {formatMln(actual)}
                                {expected != null && expected > 0 && (
                                    <span className="text-t8f95a3 ml-2 text-[11px]">
                                        (prev. {formatMlnTight(expected)})
                                    </span>
                                )}
                            </span>
                        </div>
                    );
                })}
                {hideHint && (
                    <div className="op-mono text-[10px] text-t5c6370 italic pt-2 border-t border-t22252a mt-2">
                        {hideHint}
                    </div>
                )}
            </div>
        </div>
    );
}

